"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgEmptyFacilities = function SvgEmptyFacilities(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 166 99",
    role: "img"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "empty-facilities_svg__a",
    d: "M85.624 0c10.587 0 19.191 8.491 19.373 19.035l.003.341h-.003l.003.13A4.5 4.5 0 0 1 100.712 24l-.212.005a4.5 4.5 0 0 1-4.498-4.63H96C96 13.773 91.458 9.23 85.854 9.23H84c-6.627 0-12 5.373-12 12v5.776h21c6.627 0 12 5.372 12 12v31c0 6.627-5.373 12-12 12H75c-6.627 0-12-5.373-12-12V21C63 9.402 72.402 0 84 0h1.624z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "empty-facilities_svg__b",
    width: 42,
    height: 82.006,
    x: 0,
    y: 0,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#empty-facilities_svg__a"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10 17.006-5.878 3.09 1.123-6.545L.489 8.916l6.572-.955L10 2.006l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545zm142 5.558-8.652 4.442L145 17.599l-7-6.662 9.674-1.373L152 1.006l4.326 8.558L166 10.937l-7 6.662 1.652 9.407zm-24.5 74.392-4.017 2.05.767-4.342L121 91.59l4.491-.633 2.009-3.95 2.009 3.95 4.491.633-3.25 3.075.767 4.342z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(70 46.006)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    fill: "#17181A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 2,
    r: 2,
    fill: "#17181A"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#17181A",
    d: "M4 14c7.113-2.667 14.113-2.667 21 0"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E1F3FF",
    d: "M89 27.006h4c6.627 0 12 5.372 12 12v31c0 6.627-5.373 12-12 12h-4c6.627 0 12-5.373 12-12v-31c0-6.628-5.373-12-12-12zM81.854 9.23c.348 0 .692.018 1.03.052C76.78 9.844 72 14.979 72 21.23v5.776h-4V21.23c0-6.627 5.373-12 12-12zM85.624 0c10.587 0 19.191 8.491 19.373 19.035l.003.341h-.003l.003.13A4.5 4.5 0 0 1 100.712 24l-.212.005a4.481 4.481 0 0 1-2-.468 4.5 4.5 0 0 0 2.5-4.032l-.003-.13H101l-.003-.34C100.822 8.88 92.834.628 82.787.033 83.188.012 83.593 0 84 0h1.624z"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#C2C5CC",
    strokeDasharray: 2,
    strokeLinejoin: "round",
    strokeWidth: 2,
    mask: "url(#empty-facilities_svg__b)",
    xlinkHref: "#empty-facilities_svg__a"
  })));
};

var Memo = /*#__PURE__*/(0, React.memo)(SvgEmptyFacilities);
var _default = Memo;
exports["default"] = _default;